// import { S3 } from '../awsConfig/index';
import {  
  GENERATE_STATE_AND_NONCE, 
  RECEIVE_ACCESS_TOKEN, 
  RECEIVE_ID_TOKEN, 
  RECEIVE_PROFILE_DATA, 
  CLEAR_ALL,
  TOKEN_EXPIRED, 
  } from "../actions/types";


export const generateStateAndNonce = () => ({
  type: GENERATE_STATE_AND_NONCE
});

export const receiveAccessToken = accessToken => ({
  type: RECEIVE_ACCESS_TOKEN,
  payload: { accessToken }
});

export const receiveIdToken = idToken => ({
  type: RECEIVE_ID_TOKEN,
  payload: { idToken }
});

export const receiveProfileData = profile => ({
  type: RECEIVE_PROFILE_DATA,
  payload: { profile }
});

export const logout = () => ({
  type: CLEAR_ALL
})

export const tokenExpired = (payload) => ({
  type: TOKEN_EXPIRED,
  payload
})
